<div [ngClass]="{  'p-6': !isHandset() }">
    <!-- Header Section -->
    <div class="flex justify-between items-center mb-6">
        @if (isHandset()) {
        <h3 class="text-lg font-semibold text-gray-900">Operators Management</h3>
        }
        @else {
        <h1 class="text-2xl font-semibold text-gray-900">Operators Management</h1>
        }

        <!-- Action Buttons -->
        <div class="flex items-center gap-2">
            <!-- Filter Button -->
            @if (isHandset()) {
            <button mat-icon-button (click)="openFilterDialog()" title="Filter operators"
                [attr.aria-label]="'Filter operators'" class="filter-button">
                <mat-icon>filter_list</mat-icon>
            </button>
            }
            @else {
            <jjames-button variant="secondary" (clicked)="openFilterDialog()" iconLeft="fas fa-filter"
                class="filter-button" matIconLeft="filter_list">
                Filters
            </jjames-button>
            }

            <!-- Create Button -->
            @if (isHandset()) {
            <button mat-fab color="primary" (click)="onCreateOperator()" title="New operator"
                [attr.aria-label]="'New operator'" class="enhanced-fab">
                <mat-icon class="enhanced-icon">add</mat-icon>
            </button>
            }
            @else {
            <jjames-button variant="primary" (clicked)="onCreateOperator()" class="enhanced-button" matIconLeft="add">
                New Operator
            </jjames-button>
            }
        </div>
    </div>

    <!-- Content Section -->
    <div class="space-y-6">
        <!-- Loading State -->
        @if (isLoading) {
        <div class="flex flex-col items-center justify-center py-12 space-y-4">
            <mat-spinner diameter="50" class="custom-spinner"></mat-spinner>
            <div class="text-center">
                <h3 class="text-lg font-medium text-gray-900 mb-2">Loading operators...</h3>
                <p class="text-gray-500">Please wait while we fetch the operator data.</p>
            </div>
        </div>
        }
        <!-- Operators List -->
        @else if (operators()?.items && operators()!.items!.length > 0) {
        <div class="space-y-6">
            <app-operators-list [operators]="operators()?.items??[]" [paginationConfig]="pagination"
                [isLoading]="isLoading" (pageChange)="onPageChange($event)" (editOperator)="onEditOperator($event)"
                (deleteOperator)="onDeleteOperator($event)" (viewOperatorDetails)="onViewOperatorDetails($event)"
                (assignParkingSpace)="onAssignParkingSpace($event)"
                (unassignParkingSpace)="onUnassignParkingSpace($event)">
            </app-operators-list>
        </div>
        } @else {
        <!-- Empty State -->
        <jjames-card class="text-center py-12">
            <div class="flex flex-col items-center space-y-4">
                <svg class="h-16 w-16 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                <div class="space-y-2">
                    <h3 class="text-lg font-medium text-gray-900">No operators found</h3>
                    <p class="text-gray-500 max-w-sm">No parking operators match your current filters. Try adjusting
                        your search criteria or create a new operator.</p>
                </div>
                <jjames-button variant="primary" (clicked)="onCreateOperator()" iconLeft="fas fa-plus">
                    Create your first operator
                </jjames-button>
            </div>
        </jjames-card>
        }
    </div>
</div>